import React from 'react';
import { BookOpenIcon } from 'lucide-react';
type CoverPendingProps = {
  title: string;
  compact?: boolean;
};
/** Tijdelijke tekstuele weergave tot de eigenaar de echte omslag aanlevert. */
export function CoverPending({
  title,
  compact = false
}: CoverPendingProps) {
  if (compact) {
    return <div className="flex h-full w-full items-center justify-center bg-lilac text-plum" data-id="element-49" data-mp="1ttt5mjxzw265">
        <BookOpenIcon size={22} aria-hidden="true" data-id="element-50" data-mp="28qtm1raqkapb" />
      </div>;
  }
  return <div className="flex h-full w-full flex-col items-center justify-center gap-4 bg-lilac p-10 text-center" data-id="element-51" data-mp="28p0g6e7y5uid">
      <BookOpenIcon size={32} aria-hidden="true" className="text-berry-deep" data-id="element-52" data-mp="2hjnekqf716l4" />
      <p className="max-w-[16rem] font-serif text-2xl font-semibold leading-snug text-plum" data-id="element-53" data-mp="2hlrg51pmdti8">{title}</p>
      <p className="text-sm text-ink/70" data-id="element-54" data-mp="2dkfpcsv0f28g">Omslag volgt</p>
    </div>;
}